// The view-only table (decision 37, issue 1383) as the client reads it: its own module, depending on nothing of the
// client's, so the table state, the shell and a test that stands a table state in all read the one test.
import { ACT_POWER, type Power, type Role } from '@dragons-table/vtt-shared';

/** What a refused act at a view-only table says, and why a control is greyed there. */
export const VIEW_ONLY_REASON = 'The DM is away, so the table is view-only until they are back.';

/**
 * Whether an act of `kind` would be refused because the table is view-only: the server's own test (`socket.ts`) —
 * past the DM's grace, anyone not acting as the DM changes nothing but where they point. The DM (`powers` null) is
 * never restricted, nor a co-DM acting with a power they hold (`actingRole`). A control reads this beside the status
 * the server sends, so the control and the refusal cannot disagree.
 */
export function viewOnlyFor(viewOnly: boolean, role: Role, powers: readonly Power[] | null, kind: string): boolean {
  if (!viewOnly || kind === 'focus.set' || kind === 'focus.clear') return false;
  if (powers === null) return role !== 'dm';
  const need = ACT_POWER[kind];
  return !(need !== undefined && need !== 'dm' && powers.includes(need));
}
